// extracted by mini-css-extract-plugin
export default {"collapsibleContent":"CollapsibleSection_collapsibleContent__4wgEL","collapsibleContentOpen":"CollapsibleSection_collapsibleContentOpen__vZFfP"};